import { cn } from '@/lib/utils';
import type { VehicleFromIndexer } from '@/models/types';
import { Button } from '../../ui/button';
import { AUTOPILOT_OPTIONS_MAP } from './autopilot-selector';

export const AutopilotBadge = ({
  value,
  hideCopy = false,
  buttonRef,
  className,
  buttonVariant = 'ghost',
}: {
  value: VehicleFromIndexer['autopilot_features'];
  hideCopy?: boolean;
  buttonRef?: React.RefObject<HTMLButtonElement | null>;
  className?: string;
  buttonVariant?: 'outline' | 'ghost';
}) => {
  return (
    <Button
      variant={buttonVariant}
      className={cn('p-1 h-fit', className)}
      ref={buttonRef}
    >
      {!hideCopy && (
        <p className="rounded text-xs  text-gray-600">
          {
            AUTOPILOT_OPTIONS_MAP.find((option) => option.value === value)
              ?.label
          }
        </p>
      )}
    </Button>
  );
};
